// extracted by mini-css-extract-plugin
export default {"play-btn":"PlayButton_play-btn__8NgCv","small":"PlayButton_small__XFN3A"};